module.exports = __webpack_public_path__ + "static/media/CORTE.54fd71a7.mp4";